<script>
import { useAdmin } from 'dashboard/composables/useAdmin';
import BackButton from '../../../../components/widgets/BackButton.vue';
import SearchInput from './SearchInput.vue';
import { ref } from 'vue';
import Icon from 'next/icon/Icon.vue';

export default {
  components: {
    BackButton,
    SearchInput,
    Icon,
  },

  props: {
    headerTitle: {
      default: '',
      type: String,
    },
    buttonRoute: {
      default: '',
      type: String,
    },
    buttonText: {
      default: '',
      type: String,
    },
    icon: {
      default: '',
      type: String,
    },
    showBackButton: { type: Boolean, default: false },
    showNewButton: { type: Boolean, default: false },
    backUrl: {
      type: [String, Object],
      default: '',
    },
    backButtonLabel: {
      type: String,
      default: '',
    },
    showSidemenuIcon: {
      type: Boolean,
      default: true,
    },
    listLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['search', 'refresh'],
  setup() {
    const { isAdmin } = useAdmin();
    const searchQuery = ref('');

    return {
      isAdmin,
      searchQuery,
    };
  },
  computed: {
    iconClass() {
      return `icon ${this.icon} header--icon`;
    },
  },
  methods: {
    debounceSearch(e) {
      this.searchQuery = e.target.value;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(async () => {
        if (this.searchQuery.length > 2 || this.searchQuery.match(/^[0-9]+$/)) {
          this.$emit('search', this.searchQuery);
        } else {
          this.$emit('search', '');
        }
      }, 500);
    },
    emitRefresh() {
      if (this.listLoading) return;
      this.$emit('refresh');
    },
  },
};
</script>

<template>
  <div
    class="flex flex-col px-4 pt-2 bg-white dark:bg-slate-900 border-b border-slate-50 dark:border-slate-800/50"
  >
    <SearchInput
      class="mb-8"
      search-placeholder="Pesquisar..."
      :search-term="searchQuery"
      @input="debounceSearch"
    />
    <div class="flex justify-between items-center mb-8 gap-4 flex-wrap">
      <h1
        class="flex items-center mb-0 text-2xl text-slate-900 dark:text-slate-100 min-w-0"
      >
        <woot-sidemenu-icon v-if="showSidemenuIcon" />
        <BackButton
          v-if="showBackButton"
          :button-label="backButtonLabel"
          :back-url="backUrl"
          class="ml-2 mr-4 shrink-0"
        />
        <fluent-icon
          v-if="icon"
          :icon="icon"
          :class="iconClass"
          class="hidden ml-1 mr-2 rtl:ml-2 rtl:mr-1 md:block"
        />
        <slot />
        <span class="text-2xl font-medium text-slate-900 dark:text-slate-100">
          {{ $t(headerTitle) }}
        </span>
      </h1>
      <div class="flex items-center gap-3 shrink-0">
        <button
          type="button"
          class="group relative flex items-center gap-2 px-4 py-2 bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 rounded-lg transition-all duration-200 ease-in-out shadow-sm hover:shadow-md border border-slate-200 dark:border-slate-700 disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none disabled:hover:bg-slate-100 dark:disabled:hover:bg-slate-800 disabled:hover:shadow-sm"
          :disabled="listLoading"
          :aria-label="$t('COMMENTS.MODERATION.REFRESH_ARIA')"
          :title="$t('COMMENTS.MODERATION.REFRESH_ARIA')"
          @click="emitRefresh"
        >
          <Icon
            icon="i-lucide-refresh-cw"
            class="size-4 text-slate-600 dark:text-slate-400 shrink-0 motion-safe:transition-transform"
            :class="{ 'motion-safe:animate-spin': listLoading }"
          />
          <span class="text-sm font-medium">
            {{ $t('COMMENTS.MODERATION.REFRESH') }}
          </span>
        </button>
        <router-link
          v-if="showNewButton && isAdmin"
          :to="buttonRoute"
          class="button success button--fixed-top px-3.5 py-1 rounded-[5px] flex gap-2"
        >
          <fluent-icon icon="add-circle" />
          <span class="button__content">
            {{ buttonText }}
          </span>
        </router-link>
      </div>
    </div>
  </div>
</template>
